// RankedList.jsx — Task 11 artifact slot. Ordered rows with optional value + sub-line.
// Props: { title?, items:[{ rank?, label, value?, sub? }] }.
import React from "react"

export default function RankedList({ title, items }) {
  if (!Array.isArray(items) || items.length === 0) return null
  return (
    <div className="afq-card" data-slot="ranked_list">
      {title ? <div className="afq-card-h"><h2>{title}</h2></div> : null}
      <div className="afq-ranked">
        {items.map((it, i) => {
          // Tolerate reasonable key variance: canonical is `label`/`sub`, the live agent also uses
          // `name`/`meta` (G-LIVE session 77 + design mock shape).
          const label = it.label != null ? it.label : it.name
          const sub = it.sub != null ? it.sub : it.meta
          return (
            <div className="afq-rank-row" key={i}>
              <span className="afq-rank-n">{it.rank != null ? it.rank : i + 1}</span>
              <div className="afq-rank-main">
                <div className="afq-rank-label">{label}</div>
                {sub ? <div className="afq-rank-sub">{sub}</div> : null}
              </div>
              {it.value != null ? <span className="afq-rank-val">{String(it.value)}</span> : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}
